import { hasQueryParams } from "@/helpers/helpers";
import { mapState } from "vuex";
import Store from "@/store/index";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapState('token', ['tokens']),
    },
    beforeRouteEnter: ((to, from, next)=> {
        next({
            name: 'Profile',
            query: hasQueryParams(from)
                ? { ...from.query, unsubscribe: true }
                :  { unsubscribe: true }
        });
    }),
}
